import ShiftDetailExtended from './components/ShiftDetailExtended';
import useSearchString from '../../hooks/UrlParamsHandler/useSearchParams';

const ShiftDetailPage = ({toggleShowHistory}: {toggleShowHistory: () => void}) => {
  const [searchParams] = useSearchString();

  const shiftId = searchParams.get('shiftId') || undefined;

  if (!shiftId) return null;
  return <ShiftDetailExtended toggleShowHistory={toggleShowHistory} shiftId={Number(shiftId)} />;
};

export default ShiftDetailPage;
